import * as Yup from 'yup';

const validationSchema = values =>
  Yup.object().shape({
    email: Yup.string().required('Email is required'),
    password: Yup.string().required('Password is required'),
  });

export default validationSchema;
